export default {"src":"/_next/static/media/Hypertension.38950c20.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};